import { z } from 'zod';

import { requiredHttpsUrlSchema } from '../../../lib/schemas/formSchemas';

export const FormData = z.object({
  publisherName: z.string(),
  website: requiredHttpsUrlSchema,
  avatar: z.instanceof(File).optional(),
});

export type FormData = z.infer<typeof FormData>;
